export default {
    routerName: '个人中心',
    user: {
        icon: '头像',
        deptName: '部门名',
        name: '姓名',
        loginName: '账号',
        email: '邮箱',
        pwd: '密码',
        password: '现在的密码',
        newPassword: '新密码',
        newPasswordConfirm: '新密码确认',
        mobile: '电话',
        type: '用户类型',
        systemUser: '系统用户',
        normalUser: '普通用户',
        members: '会员用户',
        sex: '性别',
        status: '状态',
        remark: '备注',
        male: '男性',
        female: '女性',
        open: '开启',
        close: '停用',
        postName: '岗位',
        roleName: '角色',
    },
    base: {
        info: '基本信息',
    },
};
